import React from "react";

const Blog = () => {
    return (
        <>
            <div className="bg-white">
                <div className="max-w-screen-xl mx-auto p-5 sm:p-10 md:p-16 ">
                    <div className="border-b mb-5 flex justify-between text-sm">
                        <div className="text-indigo-600 flex items-center pb-2 pr-2 border-b-2 border-indigo-600 uppercase">
                            <span className="font-semibold inline-block">
                                Recent Blogs
                            </span>
                        </div>
                        <button>See All</button>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
                        <div className="rounded overflow-hidden shadow-lg flex flex-col">
                            <a href="/">
                                <img
                                    className="w-full"
                                    src="https://media.istockphoto.com/photos/technician-carefully-examines-the-integrity-of-the-internal-elements-picture-id1189142091?k=20&m=1189142091&s=612x612&w=0&h=NoWDtr8e5PwQ_SsI8GTDyUKpzMMkreOxfn4EWOW-xeQ="
                                    alt="Sunset in the mountains"
                                />
                            </a>
                            <div className="px-6 py-4 mb-auto">
                                <div className="mb-3">
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        Mobile Repaing
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        guide
                                    </a>
                                </div>
                                <a
                                    href="/"
                                    className="font-medium text-lg hover:text-indigo-600 transition duration-500 ease-in-out inline-block mb-2"
                                >
                                    Simplest way ever
                                </a>
                                <p className="text-gray-500 text-sm">
                                    Easily Repair any mobile phone. First of all
                                    you need know what is the problem.
                                </p>
                            </div>
                            <div className="flex items-center px-6 pb-4">
                                <a href="/">
                                    <img
                                        className="w-12 h-12 rounded-full mr-2"
                                        src="https://tailwindcss.com/img/jonathan.jpg"
                                        alt="Avatar of Jonathan Reinink"
                                    />
                                </a>
                                <div className="text-sm">
                                    <a
                                        href="/"
                                        className="text-gray-900 font-medium leading-none hover:text-indigo-600"
                                    >
                                        Jonathan Reinink
                                    </a>
                                    <p className="text-gray-600">Aug 18</p>
                                </div>
                            </div>
                        </div>
                        <div className="rounded overflow-hidden shadow-lg flex flex-col">
                            <a href="/">
                                <img
                                    className="w-full"
                                    src="https://media.istockphoto.com/photos/repairman-disassembling-phone-with-screwdriver-picture-id831986696?k=20&m=831986696&s=612x612&w=0&h=jPuce3QxuAO6bdYIQLZ9kSZOnDmyk1xEMZOGeYckCNY="
                                    alt="Sunset in the mountains"
                                />
                            </a>
                            <div className="px-6 py-4 mb-auto">
                                <div className="mb-3">
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        Disply Repairng
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        Smartphone
                                    </a>
                                </div>
                                <a
                                    href="/"
                                    className="font-medium text-lg  hover:text-indigo-600 transition duration-500 ease-in-out inline-block mb-2 capitalize"
                                >
                                    Without Damage
                                </a>
                                <p className="text-gray-500 text-sm">
                                    Display reparing is one of the ticky work
                                    for you. Here have an simple ticks.
                                </p>
                            </div>
                            <div className="flex items-center px-6 pb-4">
                                <a href="/">
                                    <img
                                        className="w-12 h-12 rounded-full mr-2"
                                        src="https://tailwindcss.com/img/jonathan.jpg"
                                        alt="Avatar of Jonathan Reinink"
                                    />
                                </a>
                                <div className="text-sm">
                                    <a
                                        href="/"
                                        className="text-gray-900 font-medium leading-none hover:text-indigo-600"
                                    >
                                        Jonathan Reinink
                                    </a>
                                    <p className="text-gray-600">Aug 18</p>
                                </div>
                            </div>
                        </div>
                        <div className="rounded overflow-hidden shadow-lg flex flex-col">
                            <a href="/">
                                <img
                                    className="w-full"
                                    src="https://us.123rf.com/450wm/milkos/milkos1710/milkos171001446/87665844-repairing-smartphone-with-multimeter-close-up-technician-pov-broken-phone-diagnostics-at-service-cen.jpg?ver=6"
                                    alt="Sunset in the mountains"
                                />
                            </a>
                            <div className="px-6 py-4 mb-auto">
                                <div className="mb-3">
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        Soldering
                                    </a>
                                    ,{" "}
                                    <a
                                        href="/"
                                        className="text-xs text-indigo-600 transition duration-500 ease-in-out"
                                    >
                                        speaker
                                    </a>
                                </div>
                                <a
                                    href="/"
                                    className="font-medium text-lg  hover:text-indigo-600 transition duration-500 ease-in-out inline-block mb-2"
                                >
                                    Soldring Ticks
                                </a>
                                <p className="text-gray-500 text-sm">
                                    Soldering Diplay is disgusting. No problem
                                    you can fixed it eaisyly
                                </p>
                            </div>
                            <div className="flex items-center px-6 pb-4">
                                <a href="/">
                                    <img
                                        className="w-12 h-12 rounded-full mr-2"
                                        src="https://tailwindcss.com/img/jonathan.jpg"
                                        alt="Avatar of Jonathan Reinink"
                                    />
                                </a>
                                <div className="text-sm">
                                    <a
                                        href="/"
                                        className="text-gray-900 font-medium leading-none hover:text-indigo-600"
                                    >
                                        Jonathan Reinink
                                    </a>
                                    <p className="text-gray-600">Aug 18</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Blog;
